import React from 'react';
import ReportLayout, { StatusChip, fmtDateTime, fmtDuration } from './ReportLayout';

const COLUMNS = [
  { key: 'pass_id', label: 'Pass ID', sortable: false },
  { key: 'name', label: 'Candidate', sortable: true },
  { key: 'phone', label: 'Phone', sortable: false },
  { key: 'purpose', label: 'Purpose / Post', sortable: false },
  { key: 'company', label: 'Company', sortable: false },
  { key: 'to_meet', label: 'Interviewing With', sortable: false },
  { key: 'check_in', label: 'Check-In', render: v => fmtDateTime(v) },
  { key: 'check_out', label: 'Check-Out', sortable: false, render: v => fmtDateTime(v) },
  { key: 'duration_minutes', label: 'Duration', sortable: false, render: v => fmtDuration(v) },
  { key: 'display_status', label: 'Status', sortable: false, render: v => <StatusChip value={v} /> },
  { key: 'created_at', label: 'Registered At', render: v => fmtDateTime(v) },
];

const FILTERS = [
  {
    type: 'select',
    name: 'status',
    label: 'Status',
    defaultValue: 'all',
    options: [
      { value: 'expected', label: 'Expected (Approved)' },
      { value: 'checked_in', label: 'Checked In' },
      { value: 'checked_out', label: 'Checked Out' },
      { value: 'pending', label: 'Pending Approval' },
      { value: 'rejected', label: 'Rejected' },
    ],
  },
  {
    type: 'userSelect',
    name: 'assigned_employee_id',
    label: 'Interviewing With',
  },
];

export default function CandidateReport() {
  return (
    <ReportLayout
      title="Candidate Visits"
      description="All candidate interviews and visits registered at the gate"
      endpoint="/reports/candidates"
      columns={COLUMNS}
      filters={FILTERS}
      defaultSort="created_at"
      defaultOrder="desc"
      exportFilename="candidate-visits"
    />
  );
}
